import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import profileReducer from "./slices/profileSlice";
import newsfeedReducer from "./slices/newsfeedSlice";
import connectionReducer from "./slices/connectionSlice";
import messagingReducer from "./slices/messagingSlice";
import notificationsReducer from "./slices/notificationsSlice";
import directoryReducer from "./slices/directorySlice";
import searchReducer from "./slices/searchSlice";
import newsReducer from "./slices/newsSlice";

const store = configureStore({
    reducer: {
        auth: authReducer,
        profile: profileReducer,
        newsfeed: newsfeedReducer,
        connection: connectionReducer,
        messaging: messagingReducer,
        notifications: notificationsReducer,
        directory: directoryReducer,
        search: searchReducer,
        news: newsReducer,
    },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
